import * as React from 'react';

export interface IAnonymityThresholdLoaderProps {
	surveyId: number;
	minN?: number;
	GetClientMinN: () => void;
	GetSurveyMinN: (surveyId: number) => void;
}

export class AnonymityThresholdLoader extends React.Component<IAnonymityThresholdLoaderProps> {
	public componentDidMount() {
		this.props.GetSurveyMinN(this.props.surveyId);
		this.props.GetClientMinN();
	}

	public render() {
		return <></>;
	}
}
